import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

import type { ShopifyInstalledSubscription } from "~/graphql/graphql-new.gen";
import { ShopifyInstalledDocument } from "~/graphql/graphql-new.gen";
import { useBrandQuery } from "~/graphql/graphql.gen";

import { useGraphQLSubscription } from "./use-graphql-subscription";

export const useShopifyInstalledSubscription = () => {
  const client = useGraphQLSubscription();
  const queryClient = useQueryClient();
  useEffect(() => {
    const unsubscribe = client.subscribe<ShopifyInstalledSubscription>(
      {
        query: ShopifyInstalledDocument,
      },
      {
        next: (data) => {
          if (!data.data?.shopifyInstalled) return;
          queryClient.invalidateQueries({
            queryKey: useBrandQuery.getKey(undefined),
          });
        },
        error: (error) => {
          // TODO: Handle error
          console.error(error);
        },
        complete: () => {
          // Do nothing
        },
      },
    );

    return () => {
      unsubscribe();
    };
  }, [client, queryClient]);
};
